var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare3Stack3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76295 1.05976C7.91094 0.980079 8.08906 0.980079 8.23705 1.05976L14.7371 4.55976C14.899 4.64697 15 4.81606 15 5C15 5.18394 14.899 5.35303 14.7371 5.44024L8.23705 8.94024C8.08906 9.01992 7.91094 9.01992 7.76295 8.94024L1.26295 5.44024C1.101 5.35303 1 5.18394 1 5C1 4.81606 1.101 4.64697 1.26295 4.55976L7.76295 1.05976Z",
    fill: "#010F55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17645 7.06787L7.28885 9.8207C7.73281 10.0598 8.26719 10.0598 8.71115 9.8207L13.8235 7.06787L14.7371 7.55976C14.899 7.64696 15 7.81605 15 7.99999C15 8.18393 14.899 8.35302 14.7371 8.44023L8.23705 11.9402C8.08906 12.0199 7.91094 12.0199 7.76295 11.9402L1.26295 8.44023C1.101 8.35302 1 8.18393 1 7.99999C1 7.81605 1.101 7.64696 1.26295 7.55976L2.17645 7.06787Z",
    fill: "#010F55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28885 12.8207L2.17645 10.0679L1.26295 10.5598C1.101 10.647 1 10.8161 1 11C1 11.1839 1.101 11.353 1.26295 11.4402L7.76295 14.9402C7.91094 15.0199 8.08906 15.0199 8.23705 14.9402L14.7371 11.4402C14.899 11.353 15 11.1839 15 11C15 10.8161 14.899 10.647 14.7371 10.5598L13.8235 10.0679L8.71115 12.8207C8.26719 13.0598 7.73281 13.0598 7.28885 12.8207Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare3Stack3D);
export default __webpack_public_path__ + "static/media/Square3Stack3d.9d52b79c24047f6265a806edf006d69e.svg";
export { ForwardRef as ReactComponent };